<template>
  <div class="mt-4">
    <input
      type="hidden"
      id="changelog_entry_published_at"
      name="changelog_entry[published_at]"
      :value="published_at"
    />

    <div class="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 p-3 bg-neutral-50 border border-neutral-200 rounded-xl">
      <!-- Left side: Schedule picker -->
      <div class="flex-shrink-0">
        <v-date-picker
          v-model="published_at"
          mode="dateTime"
          color="gray"
          is24hr
          :attributes="attrs"
        >
          <template #default="{ inputValue, togglePopover }">
            <button
              type="button"
              @click="openSchedule(togglePopover)"
              class="btn justify-center whitespace-nowrap"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
              </svg>
              <span class="truncate max-w-[180px]">
                {{ isNow ? $t('Now') : formatDateTime(published_at) }}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 ml-1">
                <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
              </svg>
            </button>
          </template>
        </v-date-picker>
      </div>

      <!-- Right side: Actions -->
      <div class="flex items-center gap-2 sm:gap-3">
        <!-- AI button (optional) -->
        <button
          v-if="changelogSuggestions == 'true' && subscription_valid == 'true'"
          type="button"
          class="btn justify-center whitespace-nowrap"
          @click.prevent="suggestChangelog()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-amber-500 mr-1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
          </svg>
          <span class="hidden sm:inline">{{ $t('Write with AI') }}</span>
        </button>

        <!-- Save as draft -->
        <button
          type="submit"
          class="btn justify-center whitespace-nowrap"
          :class="{ 'opacity-60 cursor-not-allowed': has_pending_uploads }"
          :disabled="has_pending_uploads"
          @click="saveAsDraft"
        >
          {{ getAccordingToAlreadyPublised }}
        </button>

        <!-- Publish/Schedule -->
        <button
          type="submit"
          class="btn-main justify-center whitespace-nowrap"
          :class="{ 'opacity-60 cursor-not-allowed': has_pending_uploads }"
          :disabled="has_pending_uploads"
          @click="change_btn"
        >
          {{ getAccordingToButtonStatus }}
        </button>
      </div>
    </div>
    <p
      v-if="has_pending_uploads"
      class="mt-2 text-xs text-neutral-600"
    >
      {{ $t('Uploading image. Please wait before publishing.') }}
    </p>

    <ChangelogSuggestModal
      :show-suggestion-modal="showSuggestionModal && subscription_valid == 'true'"
      @close-modal="closeModal()"
    />
  </div>
</template>

<script>
import EventBus from "../event_bus";
import ChangelogSuggestModal from "./changelog_suggest_modal";
export default {
  props: ["current-value", "created-at", "subscription_valid", "already-post", "show-ai-message", "changelog-suggestions"],
  data: function () {
    return {
      published_at: new Date(),
      isNow: this.currentValue === "",
      button_status: true,
      already_published: false,
      cta_word: "Publish",
      changelog_body: false,
      changelog_title: false,
      has_pending_uploads: false,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      attrs: [
        {
          key: "today",
          highlight: {
            fillMode: "light",
          },
          dates: new Date(),
        },
      ],
      showSuggestionModal: false,
      posts: [],
    };
  },
  components: { ChangelogSuggestModal },
  computed: {
    getAccordingToButtonStatus(){
      if(this.alreadyPost == 'true'){
        return this.$t("Save")
      }
      return this.button_status ? this.$t("Publish") : this.$t("Schedule")
    },
    getAccordingToAlreadyPublised(){
      return this.already_published ? this.$t("Unpublish") : this.$t("Save as draft")
    }
  },
  mounted() {
    this.formElement = this.$el.closest("form");
    this.formSubmitHandler = (event) => {
      if (this.has_pending_uploads) {
        event.preventDefault();
        return;
      }

      if (this.hasRequiredContent()) {
        this.clearChangelogDraft();
      }
    };

    this.formElement?.addEventListener("submit", this.formSubmitHandler);
  },
  created() {
    if (this.currentValue) {
      this.published_at = new Date(this.currentValue.replace(/-/g,'/'));

      if (this.published_at < new Date()) {
        this.already_published = true;
        this.cta_word = "Save";
      }
    } else {
      this.published_at = new Date();
    }
    this.changelogTextAddedHandler = (data) => {
        this.changelog_body = data.body
        this.changelog_title = data.title
    };
    this.uploadStateHandler = (data) => {
      if (!data || data.inputId !== "changelog_entry_body") return;
      this.has_pending_uploads = !!data.isUploading;
    };
    EventBus.$on("changelogTextAdded", this.changelogTextAddedHandler);
    EventBus.$on("richTextUploadStateChanged", this.uploadStateHandler);
  },
  methods: {
    openSchedule(toggle) {
      this.isNow = false;
      toggle();
    },
    hasRequiredContent() {
      return !!this.changelog_body && !!this.changelog_title;
    },

    clearChangelogDraft() {
      EventBus.$emit("clearRichTextDraft", {
        inputId: "changelog_entry_body",
        draftId: "changelog_entry"
      });
    },

    saveAsDraft(e) {
      if (this.has_pending_uploads) {
        e.preventDefault();
        return;
      }
      if (this.hasRequiredContent()) {
        this.clearChangelogDraft();
      }
      this.published_at = null;
    },
    change_btn(e){
      if (this.has_pending_uploads) {
        e.preventDefault();
        return;
      }
      if(!this.hasRequiredContent()){
        e.preventDefault()
        EventBus.$emit("errorChangelog", { body: !this.changelog_body, title: !this.changelog_title });
        return;
      }
      this.clearChangelogDraft();
      this.already_published = true;
    },
    suggestChangelog(){
      //this.$emit("suggest-changelog", "Trigger Changelog Suggestion AI entry");
      this.showSuggestionModal = true;
    },
    closeModal(){
      this.showSuggestionModal = false;
    },
    formatDateTime(date) {
      const options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      };
      return new Date(date).toLocaleString('en-US', options);
    },
  },
  watch: {
    published_at: function() {
      if(this.published_at < new Date()) {
        this.button_status = true
        }
      else{
        this.button_status = false
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("changelogTextAdded", this.changelogTextAddedHandler);
    EventBus.$off("richTextUploadStateChanged", this.uploadStateHandler);
    this.formElement?.removeEventListener("submit", this.formSubmitHandler);
  },
};
</script>

<style scoped lang="scss">
// VCalendar overrides
.vc-time-container {
  align-items: flex-start !important;
  justify-content: center;
}

.vc-time {
  justify-content: center !important;
}

.vc-time-container > div:first-child {
  display: none;
}

.vc-date-time {
  margin-left: 0 !important;
}
</style>
